/* Shared agency header geometry; native menu interactions remain in vivekcodes.js. */
(() => {
  'use strict';
  let dispose;
  const mount = () => {
    dispose?.();
    const slot = document.querySelector('body.vc-site-reference .dh-header-slot, body.vc-work-reference .dh-header-slot');
    const header = slot?.querySelector('.site-header');
    if (!header) return;
    const controller = new AbortController();
    const listen = (node, type, handler, options = {}) => node?.addEventListener(type, handler, { ...options, signal: controller.signal });
    let frame = 0, menuTop = -1;
    const update = () => {
      frame = 0;
      const scrolled = window.scrollY > 50;
      header.classList.toggle('is-scrolled', scrolled);
      slot.classList.toggle('is-scrolled', scrolled);
      const top = Math.max(0, Math.round((header.getBoundingClientRect().bottom + 1) * 100) / 100);
      if (top !== menuTop) {
        menuTop = top;
        header.style.setProperty('--dh-menu-top', `${top}px`);
      }
    };
    const queue = () => { if (!frame) frame = requestAnimationFrame(update); };
    listen(window, 'scroll', queue, { passive: true });
    listen(window, 'resize', queue, { passive: true });
    header.querySelectorAll('details').forEach(detail => listen(detail, 'toggle', queue));
    listen(header, 'transitionend', event => { if (event.target === header && event.propertyName === 'top') queue(); });
    const observer = window.ResizeObserver ? new ResizeObserver(queue) : null;
    observer?.observe(header);
    const announcement = document.querySelector('.dh-announcement');
    const toggle = announcement?.querySelector('[data-header-marquee-toggle]');
    listen(toggle, 'click', () => {
      const paused = announcement.classList.toggle('is-paused');
      toggle.setAttribute('aria-pressed', String(paused));
      toggle.setAttribute('aria-label', paused ? toggle.dataset.resumeLabel : toggle.dataset.pauseLabel);
    });
    dispose = () => {
      controller.abort();
      observer?.disconnect();
      if (frame) cancelAnimationFrame(frame);
      header.classList.remove('is-scrolled');
      slot.classList.remove('is-scrolled');
      header.style.removeProperty('--dh-menu-top');
      dispose = null;
    };
    update();
  };
  mount();
  document.addEventListener('shopify:section:load', mount);
  document.addEventListener('shopify:section:unload', event => {
    if (event.target?.querySelector?.('.dh-header-slot')) dispose?.();
  });
})();
